import { Controller } from "@hotwired/stimulus";
import { TypedController } from "@vytant/stimulus-decorators";

@TypedController
export default class extends Controller<HTMLDivElement> {
  connect() {
    this.element.querySelectorAll<HTMLInputElement>("#tabs input").forEach((input) => {
      input.addEventListener("change", this.changeTab.bind(this));

      if (input.checked) {
        this.changeTab(null, input);
      }
    });
  }

  changeTab(event: Event | null, input: HTMLInputElement | null = null) {
    const tab = (input || (event?.target as HTMLInputElement))?.value;
    if (!tab) return;

    let tabNameParam = "tab";
    if (this.element.dataset.tabPrefix) {
      tabNameParam = `${this.element.dataset.tabPrefix}-${tabNameParam}`;
    }

    const url = new URL(window.location.href);
    url.searchParams.set(tabNameParam, tab);

    window.history.replaceState(window.history.state, "", url.toString());
  }
}
